// extracted by mini-css-extract-plugin
export default {"relativeContainer":"DHTiu","container":"LUaQN"};